export default __webpack_public_path__ + "static/media/cert-0x-_1_ (1).db48714d.svg";